export interface UpdateDeviceLastServiceParams {
  deviceId: string;
  userId?: never;
  serviceDate: number;
  comment?: string;
}

export interface UpdateUserLastServiceParams {
  userId: string;
  deviceId?: never;
  serviceDate: number;
  comment?: string;
}

export function isUpdateDeviceServiceDateParam(
  param: UpdateDeviceLastServiceParams | UpdateUserLastServiceParams
): param is UpdateDeviceLastServiceParams {
  return 'deviceId' in param && !!param.deviceId;
}
